import { node, string } from "prop-types";

import cx from "classnames";

const propTypes = {
  children: node.isRequired,
  className: string,
  href: string,
  target: string,
};

const StyledLink = (props) => {
  const { children, href, className, target } = props;

  return (
    <a
      className={cx("styled-link", className)}
      href={href ? href : "#1"}
      target={target ? target : "_self"}
    >
      {children}
      <span>
        <>&#65279;</>
        {rightArrowIcon}
      </span>
    </a>
  );
};

StyledLink.propTypes = propTypes;
export default StyledLink;

const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-right"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
